import styled from 'styled-components';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Grid } from 'src/ui/common/atoms/grid';
import { media } from 'src/ui/common/mixins/media';

export const StyledWrapper = styled(FlexBox)`
  position: relative;
  text-align: center;
  padding: 70px 0;
  
  ${media.lg`
   padding: 130px 0;
  `}
`;

export const StyledContent = styled.div`
  position: relative;
  z-index: 3;
  color: ${({ theme }) => theme.colors.white};
  max-width: 280px;
  text-align: center;
  
  & > span:last-child {
    color: ${({ theme }) => theme.colors.gs200};
    margin-top: 10px;
  }
`;

export const StyledGrid = styled(Grid)`
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
`;

export const StyledMask = styled.div`
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  top: 0;
  height: 150px;
  background: linear-gradient(180deg, rgba(33, 31, 31, 0) 0%, #211F1F 86.05%, #211F1F 100%);
  border-radius: 5px;
`;

export const StyledCol = styled.div`
  & div {
    height: 40px;
    margin-bottom: 10px;
    background: linear-gradient(180deg, #292929 0%, rgba(41, 41, 41, 0.139535) 309.77%, rgba(41, 41, 41, 0) 360%);
    border-radius: 5px;
  }
`;